import { createAsyncThunk } from '@reduxjs/toolkit'
import { API_BASE_URL } from '../../constant'
import axios from 'axios'

axios.defaults.withCredentials = true;

/**
 * FETCH ALL ORDERS   
 */
 
export const fetchAllOrders = createAsyncThunk('order/fetchAllOrders', async ({ token }, { rejectWithValue }) => {
    try {
        const res = await axios.get(API_BASE_URL + `/allorders`, {
            headers: {
                'Authorization': `Bearer ${token}`,
            }
        })

        return res.data;

    } catch (error) {
        return rejectWithValue(error.response ? error.response.data : error.message)
    }
});

/**
 * FETCH CURRENT ORDER DETAILS  
 */
 
export const fetchCurrentOrderDetails = createAsyncThunk('order/fetchCurrentOrderDetails', async ({ token, orderNumber, id }, { rejectWithValue }) => {
    try {
        const res = await axios.get(API_BASE_URL + `/order/${orderNumber}/${id}/view`, {
            headers: {
                'Authorization': `Bearer ${token}`,
            }
        })

        return res.data;

    } catch (error) {
        return rejectWithValue(error.response ? error.response.data : error.message)
    }
});

/**
 * ADD ORDER COURIER  
 */
 
export const addOrderCourier = createAsyncThunk('order/addOrderCourier', async ({ token, id, data }, { rejectWithValue }) => {
    try {
        const res = await axios.post(API_BASE_URL + `/add-order-courier/${id}`, data, {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json',
            }
        })

        return res.data;

    } catch (error) {
        return rejectWithValue(error.response ? error.response.data : error.message)
    }
});

/**
 * UPDATE ORDER COURIER  
 */
 
export const updateOrderCourier = createAsyncThunk('order/updateOrderCourier', async ({ token, id, data }, { rejectWithValue }) => {
    try {
        const res = await axios.post(API_BASE_URL + `/update-order-courier/${id}`, data, {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json',
            }
        })

        return res.data;

    } catch (error) {
        return rejectWithValue(error.response ? error.response.data : error.message)
    }
});


/**
 * UPDATE ORDER COURIER  
 */
 
export const updateOrderDetails = createAsyncThunk('order/updateOrderDetails', async ({ token, orderNumber, id, data }, { rejectWithValue }) => {
    try {
        const res = await axios.post(API_BASE_URL + `/order/${orderNumber}/${id}/update`, data, {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json',
            }
        })

        return res.data;

    } catch (error) {
        return rejectWithValue(error.response ? error.response.data : error.message)
    }
});